(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["volgoo-faq-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-faq-hub]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const search = root.querySelector('[data-faq-search]');
    const filters = Array.from(root.querySelectorAll('[data-faq-filter]'));
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const count = root.querySelector('[data-faq-count]');
    const empty = root.querySelector('[data-faq-empty]');
    let activeCategory = 'all';
    const update = () => {
      const term = search?.value.trim().toLowerCase() || '';
      let visible = 0;
      items.forEach((item) => {
        const categoryMatch = activeCategory === 'all' || item.dataset.category === activeCategory;
        const searchMatch = !term || item.dataset.searchText.includes(term);
        item.hidden = !(categoryMatch && searchMatch);
        if (!item.hidden) visible += 1;
      });
      if (count) count.textContent = String(visible).padStart(2, '0');
      if (empty) empty.hidden = visible !== 0;
    };
    filters.forEach((filter) => filter.addEventListener('click', () => {
      activeCategory = filter.dataset.faqFilter;
      filters.forEach((item) => item.setAttribute('aria-pressed', String(item === filter)));
      update();
    }));
    search?.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volgoo-home-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-vg-product-card]').forEach((card) => {
        if (card.dataset.vgReady === 'true') return;
        card.dataset.vgReady = 'true';
        const select = card.querySelector('[data-vg-card-variant]');
        const price = card.querySelector('[data-vg-card-price]');
        const button = card.querySelector('[data-vg-card-submit]');
        if (!select || !button) return;
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          if (price) price.textContent = option.dataset.price || '';
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
        });
      });
    };
    document.querySelectorAll('[data-vg-home-products]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-vg-home-products]');
      if (section) initialize(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volgoo-installation-guide"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-installation-checklist]').forEach((list) => {
    if (list.dataset.ready === 'true') return;
    list.dataset.ready = 'true';
    const inputs = Array.from(list.querySelectorAll('input[type="checkbox"]'));
    const section = list.closest('.vg-install');
    const count = section?.querySelector('[data-installation-count]');
    const bar = section?.querySelector('[data-installation-bar]');
    const update = () => {
      const complete = inputs.filter((input) => input.checked).length;
      if (count) count.textContent = `${complete} / ${inputs.length}`;
      if (bar) bar.style.width = `${inputs.length ? complete / inputs.length * 100 : 0}%`;
    };
    inputs.forEach((input) => input.addEventListener('change', update));
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volgoo-product-compare"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-product-compare]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const choices = Array.from(root.querySelectorAll('[data-compare-choice]'));
    const products = Array.from(root.querySelectorAll('[data-compare-product]'));
    const recommendation = root.querySelector('[data-compare-recommendation] strong');
    const labels = {
      wall: root.dataset.wallRecommendation || 'Start with the wall-mounted Level 2 charger.',
      portable: root.dataset.portableRecommendation || 'Start with the portable Level 2 charger.',
      extension: root.dataset.extensionRecommendation || 'Start with the NACS extension cable.'
    };
    choices.forEach((choice) => choice.addEventListener('click', () => {
      const key = choice.dataset.compareChoice;
      choices.forEach((item) => item.setAttribute('aria-pressed', String(item === choice)));
      products.forEach((product) => product.classList.toggle('is-recommended', product.dataset.compareProduct === key));
      if (recommendation) recommendation.textContent = labels[key];
      root.querySelector(`[data-compare-product="${key}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
